import React from "react";

const TableHeaderSalePurchase = ({ data }) => {
  return (
    <div className="row p-0 m-0 mt-0  border_2_2px_top border_2_1px_bottom heading_dyn_creation_data">
      <div
        className="col-1 font_size p-0 m-0 ps-1 font-weight-bold  text-center"
        style={{ width: "3%" }}
      >
        Sr
      </div>
      <div
        className={`col-4 font_size p-0 m-0 ps-1 font-weight-bold ${data?.location === "Any" ? `` : ""
          }`}
        style={{ textAlign: "left" }}
      >
        Name of Item
      </div>
      <div
        className={`col-1 font_size p-0 m-0 pe-1 font-weight-bold ${data?.location === "Any" ? `` : ""
          }`}
        style={{ textAlign: "right", width: "5%" }}
      ></div>
      {data?.location === "Any" ? (
        <div
          className="col-2 font_size m-0 p-0 ps-1 font-weight-bold "
          style={{ textAlign: "left" }}
        >
          Location
        </div>
      ) : (
        <div
          className="col-2 font_size m-0 p-0 "
          style={{ textAlign: "left" }}
        ></div>
      )}
      <div
        className="col-1 font_size m-0 p-0 pe-1 font-weight-bold "
        style={{ textAlign: "right" }}
      >
        Quantity
      </div>
      <div
        className="col-1 font_size m-0 p-0 pe-1 font-weight-bold "
        style={{ textAlign: "right", width: "12%" }}
      >
        (Alt Unit)
      </div>
      <div
        className="col-1 font_size m-0 p-0 pe-1 font-weight-bold "
        style={{ textAlign: "right", width: "8.1%" }}
      >
        Rate
      </div>
      <div
        className="col-1 font_size m-0 p-0 ps-1 font-weight-bold "
        style={{ textAlign: "left", width: "5%" }}
      >
        Per
      </div>
      <div
        className={`col font_size m-0 p-0 pe-1 font-weight-bold text-end border_2_1px_left`}
        style={{ textAlign: "right" }}
      >
        Amount
      </div>
    </div>
  );
};

export default TableHeaderSalePurchase;
